// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gkVv","type":"styles_type__34ikc","choices":"styles_choices__3HUsQ"};